import { Controller } from "@hotwired/stimulus";
import TomSelect from "tom-select";

export default class extends Controller {
  static values = {
    optionFetchUrl: String,
    showSelected: { type: Boolean, default: true },
    selectedId: { type: Number, default: 0 },
    updateCountry: { type: Boolean, default: false },
  }

  connect() {
    this.initialized = false
    this.step = 1
    this.initializeTomSelect();
  }

  initializeTomSelect() {
    const organizationSearchUrl = this.optionFetchUrlValue
    this.tomselect = new TomSelect(this.element, {
      plugins: {
        virtual_scroll: true,
      },
      firstUrl: query => query ? `${organizationSearchUrl}?q=${encodeURIComponent(query)}` : organizationSearchUrl,
      valueField: "value",
      labelField: "name",
      searchField: ["name"],
      preload: true,
      hideSelected: !this.showSelectedValue,
      maxOptions: null,
      render: {
        loading_more: (data, escape) =>
          `<div class="loading-more-results py-2 d-flex align-items-center"><div class="spinner"></div> Loading more results </div>`,
        item: (data, escape) =>
          `<div class="${this.showSelectedValue ? '' : 'd-none'}" data-country="${data.country}">${data.name}</div>`,
      },
      load: this.loadOptions.bind(this),
      shouldLoadMore: this.shouldLoad.bind(this),
      onItemAdd: this.handleItemAdd.bind(this),
      onType: this.handleType.bind(this),
    });

    this.tomselect.on('change', () => {
      this.clearSearch();
    });
  }

  shouldLoad() {
    const dropdown_content = this.tomselect.dropdown_content
    const scroll_percent = dropdown_content.clientHeight / (dropdown_content.scrollHeight - dropdown_content.scrollTop);

    if(scroll_percent > 0.9 && this.step != null){
      this.scrollHeight = dropdown_content.scrollHeight
      this.tomselect.load()
    }

  }

  handleItemAdd(value, item) {
    if (this.updateCountryValue){
      const countryTag = document.querySelector("[id*='country']")

      if(item) {
        countryTag.value = item.dataset.country
      }
    }
  }

  loadOptions(query, callback) {
    const url = this.tomselect.getUrl(query) + `${query ? '&' : '?'}page=${this.step && !query ? this.step : query ? '1' : ''}`
    fetch(url)
      .then((response) => response.json())
      .then((result) => {
        const data = result.data;
        this.step = result.next_page

        const newOptions = [...data, ...Object.values(this.tomselect.options)]
        newOptions.sort((a, b) => {
          return a.name.localeCompare(b.name);
        });

        callback(newOptions);

        if(!this.initialized && this.selectedIdValue) {
          this.tomselect.setValue(this.selectedIdValue)
        }

        this.tomselect.dropdown_content.scrollTop = this.scrollHeight * 0.8;
        this.initialized = true;
      })
      .catch(() => callback([]));
  }

  clearSearch() {
    const searchInput = this.element.parentElement.querySelector('.ts-control input[type="text"]');

    if (searchInput) {
      searchInput.value = '';
      this.tomselect.refreshOptions();
    }
  }

  handleType(str) {
    this.tomselect.load(str)
  }
}
